import styled from 'styled-components'

import { H4 } from 'styles/components/typography'

export const H4Styled = styled(H4)`
  font-size: ${p => p.theme.typography.h3};

  :lang(ja) {
    font-weight: 600;
  }
`
